(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6134],{

/***/ 23646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Anchor; }
});

// UNUSED EXPORTS: isTrivialHref

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useCallbackRef.js
var useCallbackRef = __webpack_require__(32092);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useCommittedRef.js
var esm_useCommittedRef = __webpack_require__(92029);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useEventCallback.js
var esm_useEventCallback = __webpack_require__(78146);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useEventListener.js



/**
 * Attaches an event handler outside directly to specified DOM element
 * bypassing the react synthetic event system.
 *
 * @param element The target to listen for events on
 * @param event The DOM event name
 * @param handler An event handler
 * @param capture Whether or not to listen during the capture event phase
 */
function useEventListener_useEventListener(eventTarget, event, listener, capture) {
  if (capture === void 0) {
    capture = false;
  }

  var handler = useEventCallback(listener);
  useEffect(function () {
    var target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
    target.addEventListener(event, handler, capture);
    return function () {
      return target.removeEventListener(event, handler, capture);
    };
  }, [eventTarget]);
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useGlobalListener.js



/**
 * Attaches an event handler outside directly to the `document`,
 * bypassing the react synthetic event system.
 *
 * ```ts
 * useGlobalListener('keydown', (event) => {
 *  console.log(event.key)
 * })
 * ```
 *
 * @param event The DOM event name
 * @param handler An event handler
 * @param capture Whether or not to listen during the capture event phase
 */
function useGlobalListener(event, handler, capture) {
  if (capture === void 0) {
    capture = false;
  }

  var documentTarget = useCallback(function () {
    return document;
  }, []);
  return useEventListener(documentTarget, event, handler, capture);
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useInterval.js


/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */

function useInterval(fn, ms, paused, runImmediately) {
  if (paused === void 0) {
    paused = false;
  }

  if (runImmediately === void 0) {
    runImmediately = false;
  }

  var handle;
  var fnRef = useCommittedRef(fn); // this ref is necessary b/c useEffect will sometimes miss a paused toggle
  // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.

  var pausedRef = useCommittedRef(paused);

  var tick = function tick() {
    if (pausedRef.current) return;
    fnRef.current();
    schedule(); // eslint-disable-line no-use-before-define
  };

  var schedule = function schedule() {
    clearTimeout(handle);
    handle = setTimeout(tick, ms);
  };

  useEffect(function () {
    if (runImmediately) {
      tick();
    } else {
      schedule();
    }

    return function () {
      return clearTimeout(handle);
    };
  }, [paused, runImmediately]);
}

/* harmony default export */ var esm_useInterval = ((/* unused pure expression or super */ null && (useInterval)));
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useRafInterval.js



function useRafInterval(fn, ms, paused) {
  if (paused === void 0) {
    paused = false;
  }

  var handle;
  var start = new Date().getTime();
  var fnRef = useCommittedRef(fn); // this ref is necessary b/c useEffect will sometimes miss a paused toggle
  // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.

  var pausedRef = useCommittedRef(paused);

  function loop() {
    var current = new Date().getTime();
    var delta = current - start;
    if (pausedRef.current) return;

    if (delta >= ms && fnRef.current) {
      fnRef.current();
      start = new Date().getTime();
    }

    cancelAnimationFrame(handle);
    handle = requestAnimationFrame(loop);
  }

  useEffect(function () {
    handle = requestAnimationFrame(loop);
    return function () {
      return cancelAnimationFrame(handle);
    };
  }, []);
}

/* harmony default export */ var esm_useRafInterval = ((/* unused pure expression or super */ null && (useRafInterval)));
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useMergeState.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



/**
 * Mimics a React class component's state model, of having a single unified
 * `state` object and an updater that merges updates into the existing state, as
 * opposed to replacing it.
 *
 * ```js
 * const [state, setState] = useMergeState({ name: 'Betsy', age: 24 })
 *
 * setState({ name: 'Johan' }) // { name: 'Johan', age: 24 }
 *
 * setState(state => ({ age: state.age + 10 })) // { name: 'Johan', age: 34 }
 * ```
 *
 * @param initialState The initial state object
 */
function useMergeState_useMergeState(initialState) {
  var _useState = useState(initialState),
      state = _useState[0],
      setState = _useState[1];

  var updater = useCallback(function (update) {
    if (update === null) return;

    if (typeof update === 'function') {
      setState(function (state) {
        var nextState = update(state);
        return nextState == null ? state : _extends({}, state, nextState);
      });
    } else {
      setState(function (state) {
        return _extends({}, state, update);
      });
    }
  }, [setState]);
  return [state, updater];
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useMergeStateFromProps.js

function useMergeStateFromProps(props, gDSFP, initialState) {
  var _useMergeState = useMergeState(initialState),
      state = _useMergeState[0],
      setState = _useMergeState[1];

  var nextState = gDSFP(props, state);
  if (nextState !== null) setState(nextState);
  return [state, setState];
}
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useMounted.js
var useMounted = __webpack_require__(6454);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/usePrevious.js
var usePrevious = __webpack_require__(88833);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useImage.js


/**
 * Fetch and load an image for programatic use such as in a `<canvas>` element.
 *
 * @param imageOrUrl The `HtmlImageElement` or image url to load
 * @param crossOrigin The `crossorigin` attribute to set
 *
 * ```ts
 * const { image, error } = useImage('/static/kittens.png')
 * const ref = useRef<HTMLCanvasElement>()
 *
 * useEffect(() => {
 *   const ctx = ref.current.getContext('2d')
 *
 *   if (image) {
 *     ctx.drawImage(image, 0, 0)
 *   }
 * }, [ref, image])
 *
 * return (
 *   <>
 *     {error && "there was a problem loading the image"}
 *     <canvas ref={ref} />
 *   </>
 * ```
 */
function useImage(imageOrUrl, crossOrigin) {
  var _useState = useState({
    image: null,
    error: null
  }),
      state = _useState[0],
      setState = _useState[1];

  useEffect(function () {
    if (!imageOrUrl) return undefined;
    var image;

    if (typeof imageOrUrl === 'string') {
      image = new Image();
      if (crossOrigin) image.crossOrigin = crossOrigin;
      image.src = imageOrUrl;
    } else {
      image = imageOrUrl;

      if (image.complete && image.naturalHeight > 0) {
        setState({
          image: image,
          error: null
        });
        return;
      }
    }

    function onLoad() {
      setState({
        image: image,
        error: null
      });
    }

    function onError(error) {
      setState({
        image: image,
        error: error
      });
    }

    image.addEventListener('load', onLoad);
    image.addEventListener('error', onError);
    return function () {
      image.removeEventListener('load', onLoad);
      image.removeEventListener('error', onError);
    };
  }, [imageOrUrl, crossOrigin]);
  return state;
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useIsomorphicEffect.js

var isReactNative = typeof __webpack_require__.g !== 'undefined' && // @ts-ignore
__webpack_require__.g.navigator && // @ts-ignore
__webpack_require__.g.navigator.product === 'ReactNative';
var isDOM = typeof document !== 'undefined';
/**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */

/* harmony default export */ var useIsomorphicEffect = (isDOM || isReactNative ? react.useLayoutEffect : react.useEffect);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useResizeObserver.js


var targetMap = new WeakMap();
var resizeObserver;

function getResizeObserver() {
  // eslint-disable-next-line no-return-assign
  return resizeObserver = resizeObserver || new window.ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      var handler = targetMap.get(entry.target);
      if (handler) handler(entry.contentRect);
    });
  });
}
/**
 * Efficiently observe size changes on an element. Depends on the `ResizeObserver` api,
 * and polyfills are needed in older browsers.
 *
 * ```ts
 * const [ref, attachRef] = useCallbackRef(null);
 *
 * const rect = useResizeObserver(ref);
 *
 * return (
 *  <div ref={attachRef}>
 *    {JSON.stringify(rect)}
 *  </div>
 * )
 * ```
 *
 * @param element The DOM element to observe
 */


function useResizeObserver(element) {
  var _useState = useState(null),
      rect = _useState[0],
      setRect = _useState[1];

  useEffect(function () {
    if (!element) return;
    getResizeObserver().observe(element);
    setRect(element.getBoundingClientRect());
    targetMap.set(element, function (rect) {
      setRect(rect);
    });
    return function () {
      targetMap.delete(element);
    };
  }, [element]);
  return rect;
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/index.js














// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/Button.js
var Button = __webpack_require__(70861);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/Anchor.js
const _excluded = ["onKeyDown"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/anchor-has-content */




function isTrivialHref(href) {
  return !href || href.trim() === '#';
}

/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */
const Anchor = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    onKeyDown
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  const [buttonProps] = (0,Button/* useButtonProps */.FT)(Object.assign({
    tagName: 'a'
  }, props));
  const handleKeyDown = (0,esm_useEventCallback/* default */.Z)(e => {
    buttonProps.onKeyDown(e);
    onKeyDown == null ? void 0 : onKeyDown(e);
  });

  if (isTrivialHref(props.href) && !props.role || props.role === 'button') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("a", Object.assign({
      ref: ref
    }, props, buttonProps, {
      onKeyDown: handleKeyDown
    }));
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("a", Object.assign({
    ref: ref
  }, props, {
    onKeyDown: onKeyDown
  }));
});
Anchor.displayName = 'Anchor';
/* harmony default export */ var esm_Anchor = (Anchor);

/***/ }),

/***/ 62705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 44239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    getRawTag = __webpack_require__(89607),
    objectToString = __webpack_require__(2333);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 27561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(67990);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 31957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 89607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 2333:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 55639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(31957);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 67990:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 23279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218),
    now = __webpack_require__(7771),
    toNumber = __webpack_require__(14841);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 13218:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 37005:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 33448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 7771:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 14841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(27561),
    isObject = __webpack_require__(13218),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 88097:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news",
      function () {
        return __webpack_require__(75785);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 47046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ MetaTagsComp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59830);





const MetaTagsComp = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const currentUrl = "https://staging.studies-overseas.com" + (router.asPath || "");
    const { metaTitle , metaDescription , src , keywords , robotsMeta , ogimage , twitterimage , isCustomSchema , schemaJson , jotforms , canonicalUrl , isBlogPage  } = props;
    const structuredJSON = isCustomSchema && schemaJson ? schemaJson : _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultSchema */ .R4;
    const removeQueryParameters = (url)=>{
        const currentUrl = url;
        const queryIndex = currentUrl.indexOf("?");
        return queryIndex !== -1 ? currentUrl.slice(0, queryIndex) : currentUrl;
    };
    const cleanCanonicalUrl = canonicalUrl ? removeQueryParameters(canonicalUrl) : removeQueryParameters(currentUrl);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: metaTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: metaDescription
                }),
                keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "keywords",
                    content: keywords
                }),
                robotsMeta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: robotsMeta
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:url",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:type",
                    content: "Organization"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image",
                    content: ogimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:site_name",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "canonical",
                    href: cleanCanonicalUrl || canonicalUrl
                }),
                src && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    src: src
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:card",
                    content: "summary_large_image"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:site",
                    content: "@KCOverseasEdu"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:creator",
                    content: "@KCOverseasEdu"
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:image",
                    content: twitterimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                structuredJSON && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    className: "structured-data-list",
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(structuredJSON)
                    }
                })
            ]
        })
    });
};


/***/ }),

/***/ 75785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ news; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/MetaTagsComp.tsx
var MetaTagsComp = __webpack_require__(47046);
// EXTERNAL MODULE: ./styles/newsandpress.module.scss
var newsandpress_module = __webpack_require__(88100);
var newsandpress_module_default = /*#__PURE__*/__webpack_require__.n(newsandpress_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js + 1 modules
var Breadcrumb = __webpack_require__(26699);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./utils/fetchUtil.ts
var fetchUtil = __webpack_require__(40607);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./utils/applyCtaButtonProps.ts
var utils_applyCtaButtonProps = __webpack_require__(78409);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/b2c/sourceTracking.ts
var sourceTracking = __webpack_require__(3265);
// EXTERNAL MODULE: ./utils/b2c/constants.ts
var b2c_constants = __webpack_require__(90017);
;// CONCATENATED MODULE: ./components/NewsLanding.tsx




















const NewsAndPress = (props)=>{
    const router = (0,next_router.useRouter)();
    const { 0: blogsdata , 1: setBlogsdata  } = (0,react.useState)([]);
    const { 0: blogsCount , 1: setBlogsCount  } = (0,react.useState)(0);
    const { 0: filters , 1: setFilters  } = (0,react.useState)({
        searchValue: ""
    });
    const { 0: searchKeyword , 1: setSearchKeyword  } = (0,react.useState)("");
    const { 0: searchQuery , 1: setSearchQuery  } = (0,react.useState)({});
    const { 0: isViewMore , 1: setIsViewMore  } = (0,react.useState)(false);
    const { searchValue  } = filters;
    const debounceSearchQuery = (searchKeyValue)=>{
        const search = debounce_default()(()=>setFilters({
                ...filters,
                searchValue: searchKeyValue
            }), 500);
        setSearchQuery((prevSearch)=>{
            if (prevSearch.cancel) {
                prevSearch.cancel();
            }
            return search;
        });
        search();
    };
    (0,react.useEffect)(()=>{
        const searchCondition = searchValue ? `&title_contains=${searchValue}` : "";
        const limitCondition = isViewMore ? "" : "&_limit=6";
        (0,fetchUtil/* default */.Z)(`${"https://cms-staging.studies-overseas.com"}/blogs?_sort=date:DESC&_start=0&stu_dest_categories.category=News${limitCondition}${searchCondition}`, "GET", {}, "", false).then((res)=>{
            setBlogsdata(res);
        });
        (0,fetchUtil/* default */.Z)(`${"https://cms-staging.studies-overseas.com"}/blogs/count?_start=0&stu_dest_categories.category=News${searchCondition}${limitCondition}`, "GET", {}, "", false).then((res)=>{
            setBlogsCount(res);
        });
    }, [
        filters,
        isViewMore
    ]);
    const applyCtaButtonProps = (0,utils_applyCtaButtonProps/* getOnboardingOrFormCtaProps */.J)(router, {
        btnLink: props?.pageData?.bannerBtn?.btnLink,
        formId: props?.pageData?.bannerBtn?.formId,
        toOnboardingEnabled: props?.pageData?.bannerBtn?.toOnboardingEnabled
    });
    const enquireNowClickHandler = (e)=>{
        if (applyCtaButtonProps.mode === "onboarding") {
            (0,sourceTracking/* persistSourceContext */.jW)({
                sourceUrl: window.location.href,
                primarySource: b2c_constants/* PRIMARY_SOURCE_B2C_WIDGET */.ov,
                fifthStepVisible: props?.pageData?.bannerBtn?.onBoardingFlow?.nearestOffice ?? true,
                coachingVisible: props?.pageData?.bannerBtn?.onBoardingFlow?.lookingForCoaching ?? true
            });
        }
        applyCtaButtonProps.onClick?.(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "/images/newsandpress/news-bg.svg",
                        rel: "preload",
                        as: "image",
                        fetchpriority: "high"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: blogsdata?.[0]?.newimageUrl?.imageUrl,
                        rel: "preload",
                        as: "image",
                        fetchpriority: "high"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "news-press",
                className: (newsandpress_module_default()).newpress,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (newsandpress_module_default()).curve,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (newsandpress_module_default()).content,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    className: "justify-content-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                        lg: 8,
                                        md: 8,
                                        xs: 12,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "d-block d-sm-none text-center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    id: "newsand-evenetbreadcrum",
                                                    className: (newsandpress_module_default()).breadcrum,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                                        className: (newsandpress_module_default()).mobileBreadCrum,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                                style: {
                                                                    opacity: 0.5
                                                                },
                                                                href: "/",
                                                                children: "Home"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                                href: "",
                                                                children: "News and Press"
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                id: "newsnvenet-heading",
                                                className: (newsandpress_module_default()).heading,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (newsandpress_module_default()).breadcrum,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                                            className: "d-none d-sm-block",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                                    style: {
                                                                        opacity: 0.5
                                                                    },
                                                                    href: "/",
                                                                    children: "Home"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                                    href: "",
                                                                    children: "News and Press"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                        children: props.pageData?.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: props.pageData?.description
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        id: "enquirebtn",
                                                        variant: "primary",
                                                        size: "lg",
                                                        className: `${(newsandpress_module_default()).enquirebtn} btn ${applyCtaButtonProps.formClassName}`,
                                                        onClick: enquireNowClickHandler,
                                                        children: props?.pageData?.bannerBtn?.label || "Enquire Now"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (newsandpress_module_default()).latestNew,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (newsandpress_module_default()).heading,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: "Latest News"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (newsandpress_module_default()).news,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            id: "filters-drop",
                                            className: (newsandpress_module_default()).filtersDrop,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                        lg: 9,
                                                        md: 9,
                                                        xs: 12,
                                                        className: (newsandpress_module_default()).filtercheck
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                        lg: 3,
                                                        md: 3,
                                                        xs: 12,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                                            className: "navbar-form",
                                                            role: "search",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "input-group add-on",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (newsandpress_module_default()).inputBox,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                            className: "form-control",
                                                                            placeholder: "Search News",
                                                                            name: "srch-term",
                                                                            id: "srch-term",
                                                                            type: "text",
                                                                            onChange: (e)=>{
                                                                                const searchValues = e.target.value;
                                                                                debounceSearchQuery(searchValues);
                                                                                setSearchKeyword(searchValues);
                                                                            },
                                                                            value: searchKeyword
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (newsandpress_module_default()).inputBtn,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                                src: "/searchco.svg",
                                                                                alt: "searchco",
                                                                                width: 14,
                                                                                height: 14
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            id: "allLatest-news",
                                            className: (newsandpress_module_default()).allnews,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                                children: blogsdata?.length > 0 ? blogsdata.map((blog, index)=>{
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                        xxl: 4,
                                                        xl: 4,
                                                        lg: 6,
                                                        md: 6,
                                                        sm: 12,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: blog.isExternalLink && blog.externalLink ? blog.externalLink : `/news/${blog.slug}`,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                                                                className: (newsandpress_module_default()).card,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (newsandpress_module_default()).latestBlogImg,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Img */.Z.Img, {
                                                                            variant: "top",
                                                                            src: blog.newimageUrl.imageUrl,
                                                                            alt: blog.newimageUrl.alt,
                                                                            "object-fit": "fill"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                                                        className: (newsandpress_module_default()).cardBody,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                children: blog.title
                                                                            }),
                                                                            blog.shortDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: (newsandpress_module_default()).shortDescription,
                                                                                children: blog.shortDescription
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                className: (newsandpress_module_default()).bottom,
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        children: (0,format["default"])(new Date(blog.date), constants/* formatOrder */.iV)
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                        href: blog.isExternalLink && blog.externalLink ? blog.externalLink : `/news/${blog.slug}`,
                                                                                        children: [
                                                                                            " ",
                                                                                            "Read More",
                                                                                            " "
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }, index);
                                                }) : "No News"
                                            })
                                        }),
                                        blogsCount > 6 && !isViewMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                            className: "text-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                id: "news-viewmore",
                                                onClick: ()=>setIsViewMore(true),
                                                className: (newsandpress_module_default()).viewMore,
                                                children: "View More"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (newsandpress_module_default()).WhyKc,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            children: "Learn more about KC Overseas"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                    id: "learn-moreabt-kc",
                                    children: props?.pageData?.learnMore?.length > 0 && props?.pageData?.learnMore.map((data, index)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            xl: 4,
                                            md: 4,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-center mb-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (newsandpress_module_default()).img,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: data.imageUrl,
                                                            alt: data.alt,
                                                            width: 90,
                                                            height: 90
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: data.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: data.description
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: data.link.href,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: (newsandpress_module_default()).viewMore,
                                                            children: data.link.label
                                                        })
                                                    })
                                                ]
                                            })
                                        }, index);
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var NewsLanding = (NewsAndPress);

;// CONCATENATED MODULE: ./pages/news.tsx





const NewsPage = (props)=>{
    const { meta  } = props.pageData;
    (0,react.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#6C48F0");
        customStyle.setProperty("--navbar-menu-color", "#ffff");
    }, []);
    const updatedMeta = meta?.jotforms?.length === 0 ? {
        ...meta,
        jotforms: constants/* commonJotformScript */.Y4
    } : {
        ...meta
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            updatedMeta && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComp/* MetaTagsComp */.r, {
                ...updatedMeta
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsLanding, {
                ...props
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var news = (NewsPage);


/***/ }),

/***/ 40607:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const DEFAULT_TIMEOUT_MS = 8000;
const fetchUtil = async (url, method, body, ctype, useToken, useHeaders, token, timeoutMs = DEFAULT_TIMEOUT_MS)=>{
    const controller = new AbortController();
    const timer = setTimeout(()=>controller.abort(), timeoutMs);
    let options = {};
    if (method === "GET") {
        options = useHeaders ? {
            method,
            signal: controller.signal
        } : {
            method,
            headers: requestHeaders(ctype, useToken, token),
            signal: controller.signal
        };
    } else {
        options = {
            method,
            headers: requestHeaders(ctype, useToken, token),
            body: JSON.stringify(body),
            signal: controller.signal
        };
    }
    try {
        const res = await fetch(url, options);
        return await parseStatus(res.status, res);
    } finally{
        clearTimeout(timer);
    }
};
const parseStatus = (status, res)=>{
    return new Promise((resolve, reject)=>{
        if (status >= 200 && status < 300) {
            if (res.url.indexOf(".html") > -1) {
                return resolve(res);
            }
            res.json().then((response)=>resolve(response));
        } else {
            res.json().then((response)=>reject(response));
        }
    });
};
const requestHeaders = (ctype, useToken, token)=>{
    return useToken ? {
        "Content-Type": ctype || "application/json",
        Authorization: token
    } : {
        "Content-Type": ctype || "application/json"
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (fetchUtil);


/***/ }),

/***/ 88100:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"newpress":"newsandpress_newpress__y4Jn2","curve":"newsandpress_curve__D5j_Y","content":"newsandpress_content__hLFVQ","heading":"newsandpress_heading__CUElU","enquirebtn":"newsandpress_enquirebtn__ZXM97","servContent":"newsandpress_servContent__b0wbj","latestNew":"newsandpress_latestNew___GtCs","news":"newsandpress_news__CmLD5","card":"newsandpress_card__BWrEZ","latestBlogImg":"newsandpress_latestBlogImg__uWCN0","cardBody":"newsandpress_cardBody__2tH05","cardTitile":"newsandpress_cardTitile__IZSrD","shortDescription":"newsandpress_shortDescription__s2svj","bottom":"newsandpress_bottom__rLCMO","viewMore":"newsandpress_viewMore__YOa4n","filtersDrop":"newsandpress_filtersDrop__o_0yf","filtercheck":"newsandpress_filtercheck__000L6","selectdiv":"newsandpress_selectdiv__j9Iwr","Selectfilt":"newsandpress_Selectfilt__8Rqh4","recruiterFilter":"newsandpress_recruiterFilter__P8Ey0","activeSelect":"newsandpress_activeSelect__q7tMX","filterSelect":"newsandpress_filterSelect__5sZXu","selectedFilter":"newsandpress_selectedFilter__AETit","activeRecruiterFilter":"newsandpress_activeRecruiterFilter__xtIqG","mobilemenu":"newsandpress_mobilemenu__RqXcD","btn":"newsandpress_btn__OEnCe","isSticky":"newsandpress_isSticky___Jbuu","fadeInDown":"newsandpress_fadeInDown__l5_92","breadcrum":"newsandpress_breadcrum__7BhNz","buttongp":"newsandpress_buttongp__ebBZC","kcbtn":"newsandpress_kcbtn__aYCnE","centered":"newsandpress_centered__CnfdK","eduExpoBox":"newsandpress_eduExpoBox__HsczY","btEduExpo":"newsandpress_btEduExpo__ctlfj","breadcrumb-item":"newsandpress_breadcrumb-item__N3An4","active":"newsandpress_active__tAef5","hideimg":"newsandpress_hideimg__fQp3T","inputBox":"newsandpress_inputBox__giVEN","inputBtn":"newsandpress_inputBtn__k_DSb","FeaturedNews":"newsandpress_FeaturedNews__WsGAt","WhyKc":"newsandpress_WhyKc__AYO3B","img":"newsandpress_img__qkWJH","newpressdetail":"newsandpress_newpressdetail__Lo4BT","breadcrumb":"newsandpress_breadcrumb__43Y4Y","bg":"newsandpress_bg__PZiEg","imgdiv":"newsandpress_imgdiv__a4h6O","parentMain":"newsandpress_parentMain__PocJm","first":"newsandpress_first__MgPCx","filtCat":"newsandpress_filtCat__JEGPq","footerSpace":"newsandpress_footerSpace__w6mcV","btnsecondary":"newsandpress_btnsecondary__8MVz5","btnprimary":"newsandpress_btnprimary__UWN35","contain":"newsandpress_contain__pIq_c","row":"newsandpress_row__6YE_b","col":"newsandpress_col__oKDbW","catfilter":"newsandpress_catfilter__GYHYT","catSelected":"newsandpress_catSelected__MVdSQ","optfilter":"newsandpress_optfilter__1uJtr","optSelected":"newsandpress_optSelected__vW6e6","clearFilter":"newsandpress_clearFilter__vd1hc"};

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 26699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Breadcrumb; }
});

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/classnames/index.js
var classnames = __webpack_require__(44036);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/Anchor.js + 10 modules
var Anchor = __webpack_require__(23646);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/BreadcrumbItem.js





const defaultProps = {
  active: false,
  linkProps: {}
};
const BreadcrumbItem = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  active,
  children,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'li',
  linkAs: LinkComponent = Anchor/* default */.Z,
  linkProps,
  href,
  title,
  target,
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'breadcrumb-item');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(prefix, className, {
      active
    }),
    "aria-current": active ? 'page' : undefined,
    children: active ? children : /*#__PURE__*/(0,jsx_runtime.jsx)(LinkComponent, { ...linkProps,
      href: href,
      title: title,
      target: target,
      children: children
    })
  });
});
BreadcrumbItem.displayName = 'BreadcrumbItem';
BreadcrumbItem.defaultProps = defaultProps;
/* harmony default export */ var esm_BreadcrumbItem = (BreadcrumbItem);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js





const Breadcrumb_defaultProps = {
  label: 'breadcrumb',
  listProps: {}
};
const Breadcrumb = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  listProps,
  children,
  label,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'nav',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'breadcrumb');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    "aria-label": label,
    className: className,
    ref: ref,
    ...props,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("ol", { ...listProps,
      className: classnames_default()(prefix, listProps == null ? void 0 : listProps.className),
      children: children
    })
  });
});
Breadcrumb.displayName = 'Breadcrumb';
Breadcrumb.defaultProps = Breadcrumb_defaultProps;
/* harmony default export */ var esm_Breadcrumb = (Object.assign(Breadcrumb, {
  Item: esm_BreadcrumbItem
}));

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3656,9774,2888,179], function() { return __webpack_exec__(88097); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);